
export const environment = {
  production: false,
  staging: true,
  isMockEnabled: true, // You have to switch this, when your real back-end is done
  authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',

  // ----------------- Staging ------------------------------------
 contratoApiUrl:'https://contratostagingapi.viralwave.net/api/',
  staticFilesUrl:'https://contratostagingapi.viralwave.net/',
  archivingStaticFilesUrl:'https://contratostaging.viralwave.net/storage/',
  WebsiteUrl: 'https://contratostaging.viralwave.net/',
  clientId: 'cb5458fb-4df2-49ad-8d15-ec8f7a3cd53f',
  signalRUrl:'https://contratostagingapi.viralwave.net/inform',
  password:"@@XX@@##Ct"

};
